module.exports = __webpack_public_path__ + "static/img/12.e259c34.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/sp/12.png
// module id = P47T
// module chunks = 0